<template>
  <v-container fluid class="mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="6" class="d-flex justify-space-between justify-md-start">
              <v-btn color="default" class="button-shadow mb-2 mr-0 mr-sm-2" v-on:click="PrintElement('print-page')">
                <v-icon class="mr-2">mdi-printer</v-icon>
                Print
              </v-btn>
              <v-btn color="success" class="button-shadow" to="/pricelist/list">
                <v-icon class="mr-2">mdi-check</v-icon>
                Done
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12" id="print-page">
        <v-row class="print-page">
          <v-col cols="12" md="12" sm="12">
            <v-card class="ma-1">
              <v-card-text class="printBody">
                <v-row>&nbsp;</v-row>
                <v-row justify="space-between">
                  <table style="width: 100%; padding-top: 5px; padding-bottom: 5px;">
                    <tr>
                      <td style="width: 100px;"><img v-if="logo!=null" :src="logo.src" :height="logo.height" alt="Logo" /></td>
                      <td style="width:40%; padding-left: 20px;">
                        <p style="margin-top: 0;margin-bottom: 0;"><span style="white-space: pre; font-size: 9pt; text-alignment: left;">{{ companyaddress }}</span></p>
                      </td>
                      <td></td>
                      <td style="width: 35%; text-align: right; vertical-align: text-top">
                         <table style="width: 100%">
                          <tr>
                            <td><span style="font-size: 11pt; font-weight: bold">Pricelist Num</span></td>
                            <td style="text-align: right"><span style="font-size: 11pt;">{{ initvalue.pricelistnum }}</span></td>
                          </tr>
                          <tr>
                            <td><span style="font-size: 11pt; font-weight: bold">Pricelist Date</span></td>
                            <td style="text-align: right"><span style="font-size: 11pt; text-alignment: right;">{{ initvalue.pricelistdate }}</span></td>
                          </tr>
                         </table> 
                      </td>
                    </tr>
                  </table>
                </v-row>
                <div style="padding-top: 15px;padding-bottom: 15px;"></div>
                <table style="width: 100%" cellpadding="0" cellspacing="0">
                    <thead>
                    <tr>
                      <td colspan="3" style="padding-top: 5px; padding-bottom: 5px;"><div align="center"><h3 class="ma-0"><b>{{ initvalue.pricelistname }}</b></h3></div></td>
                    </tr>
                    <tr>
                      <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid; width: 2%;">#</th>
                      <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid; width: 30%;">Item</th>
                      <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid; ">Price</th>
                    </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(trans, index) in Object.keys(group_pricelist)"  v-bind:key="trans">
                          <td style="vertical-align: top;border-bottom: 1px; border-bottom-style: solid">{{ index + 1 }}</td>
                          <td style="vertical-align: top; border-bottom: 1px; border-bottom-style: solid">{{ trans }}</td>
                          <td style="text-align: left;vertical-align: top; border-bottom: 1px; border-bottom-style: solid">
                            <table width="100%">
                              <tr v-for="(item) in group_pricelist[trans]" v-bind:key="item._id">
                                <td style="white-space: nowrap; width: 25%;"><span style="font-size: 9pt;">{{ item.pricename }}:</span>  <span style="font-weight: bold">{{ item.listprice }}</span> <span style="font-size: 7pt">{{ item.currency}}</span></td>
                                <td style="padding-left: 10px;  width: 25%;">Qty {{ item.minqty }} - {{ item.maxqty }}</td>
                                <td v-if="item.foc.enable==true" style="padding-left: 10px; text-align: left; width: 50%;">
                                  <span style="font-size: 9pt;">Buy {{ item.foc.itemqty }} Get {{ item.foc.getitemqty }}</span>&nbsp;
                                  <span style="font-size: 9pt;">{{ items.length>0 ? items.find(x=>x._id==item.foc.itemid)['itemsalesdesc'] : '' }}</span>
                                </td>
                                <td v-else style="padding-left: 5px; text-align: left;">&nbsp;</td>
                              </tr>
                            </table>
                          </td>
                        </tr>                        
                    </tbody>
                </table>
                <div style="padding-top: 15px;padding-bottom: 15px;"></div>
                <table v-if="initvalue.discounts.length>0" style="width: 100%" cellpadding="0" cellspacing="0">
                    <tbody>
                        <tr>
                          <td colspan="5" style="padding-top: 5px; padding-bottom: 5px;"><div align="center"><h3 class="ma-0"><b>{{ `${initvalue.pricelisttype} Discounts` }}</b></h3></div></td>
                        </tr>
                        <tr>
                          <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid; width: 2%;">#</th>
                          <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid;">Name</th>
                          <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid; width: 20%;">Brand</th>
                          <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid; width: 20%;">Min-Max</th>
                          <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid; width: 20%;">Discount</th>
                        </tr>
                        <tr v-for="(trans, index) in initvalue.discounts"  v-bind:key="trans._id">
                          <td style="vertical-align: top;border-bottom: 1px; border-bottom-style: solid">{{ index + 1 }}</td>
                          <td style="vertical-align: top; border-bottom: 1px; border-bottom-style: solid">{{ trans.discountname }}</td>
                          <td style="vertical-align: top; border-bottom: 1px; border-bottom-style: solid">{{ brands.length>0 ? brands.find(x=>x._id==trans.brandid)['brandname'] : '' }}</td>
                          <td style="vertical-align: top; border-bottom: 1px; border-bottom-style: solid">{{ `${trans.minAmount} - ${trans.maxAmount}` }}</td>
                          <td style="vertical-align: top; border-bottom: 1px; border-bottom-style: solid">{{ getValue(trans.discounttype, trans.discountvalue) }}</td>
                        </tr>                        
                    </tbody>
                </table>
                <div style="padding-top: 15px;">
                <table v-for="(promotion) in promotions"  v-bind:key="promotion._id" style="width: 100%; padding-bottom: 10px;" cellpadding="0" cellspacing="0">
                    <tbody>
                      <tr>
                        <td colspan="5" style="padding-top: 10px; padding-bottom: 10px;"><div align="center"><h3 class="ma-0"><b>{{ `${promotion.promotionname} Promotion` }}</b></h3></div></td>
                      </tr>
                      <tr>
                        <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid; width: 2%;">#</th>
                        <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid; width: 12%">Name</th>
                        <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid;">Buy Item</th>
                        <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid; width: 15%">Group</th>
                        <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid; width: 12%;">Threshold-Limit</th>
                      </tr>
                        <tr v-for="(trans, index) in promotion.bundles"  v-bind:key="trans._id">
                          <td style="vertical-align: top;border-bottom: 1px; border-bottom-style: solid">{{ index + 1 }}</td>
                          <td style="vertical-align: top; border-bottom: 1px; border-bottom-style: solid">{{ trans.bundledesc }}</td>
                          <td style="vertical-align: top; border-bottom: 1px; border-bottom-style: solid; padding-bottom: 3px; padding-bottom: 3px;">
                            <p style="margin-top: 0; margin-bottom: 0;">{{ `Buy ${trans.buyQty}` }} x {{ items.length>0 ? items.find(x=>x._id == trans.buyItemid)['itemname'] : '' }}</p>
                            <p style="margin-top: 0; margin-bottom: 0;">{{ `Get ${trans.getQty}` }} x {{ items.length>0 ? items.find(x=>x._id == trans.getItemid)['itemname'] : '' }}</p>
                          </td>
                          <td style="vertical-align: top; border-bottom: 1px; border-bottom-style: solid">{{ `${itemsubcategories.length>0 && trans.getSubcategoryid!=null ? itemsubcategories.find(x=>x._id == trans.getSubcategoryid)['itemsubcategoryname'] : ''}` }}</td>
                          <td style="vertical-align: top; border-bottom: 1px; border-bottom-style: solid">{{ `${trans.buyThreshold} - ${trans.getLimit}` }}</td>
                      
                        </tr>                        
                    </tbody>
                </table>
                </div>
                <p style="margin-top: 0; margin-bottom: 70px">&nbsp;</p>
                <p style="margin-top: 0; margin-bottom: 0">&nbsp;</p>
              </v-card-text>
            </v-card>
          </v-col>,
        </v-row>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
    import {mapActions, mapState} from "vuex";
    import { getLogo, groupBy, sortDataAsc } from '../../../util/tools';
    export default {
        name: 'PrintPage',
        data(){
          return {
            logo: null,
            companyaddress: '',
            initvalue: {},
            group_pricelist: {},
            promotions: [],
          };
        },
        computed: {
          ...mapState('Brand', ['brands']),
          ...mapState('Item', ['items']),
          ...mapState('ItemSubcategory', ['itemsubcategories']),
          ...mapState('SalesChannel', ['saleschannels']),
        },
        methods: {
          ...mapActions('Brand', ['getBrandsRequest']),
          ...mapActions('Item', ['getItemsRequest']),
          ...mapActions('ItemSubcategory', ['getItemSubcategoriesRequest']),
          ...mapActions('Promotion', ['getPromotionsByPricelistRequest']),
          ...mapActions('SalesChannel', ['getSalesChannelsRequest']),
          ...mapActions('SystemSetting', ['getSetting']),
          PrintElement(divid) {
            var content = document.getElementById(divid).innerHTML;
            var mywindow = window.open('', 'Print', 'height=800,width=1000,menubar=0,channel=0,status=0,titlebar=0,toolbar=0');

            mywindow.document.write('<html><head><title>Print</title>');
            mywindow.document.write('</head><body onclick="window.print();">');
            mywindow.document.write(content);
            mywindow.document.write('</body></html>');

            mywindow.document.close();
            mywindow.focus()
            mywindow.print();
            return;
          },
          getValue(value_type, value){
            if(value_type=='Rate') return `${(parseFloat(value)*100)}%`;
            else return value;  
          }
        },
        async created () {
          this.initvalue = this.$route.params;
          if(!this.initvalue._id) this.$router.push({ name: 'PricelistList' });
          sortDataAsc(this.initvalue.prices, 'pricerank');
          sortDataAsc(this.initvalue.discounts, 'discountrank');


          this.group_pricelist = groupBy(this.initvalue.prices, (i)=>i.itemname, 'itemname');
          if(this.brands.length==0) await this.getBrandsRequest();
          if(this.items.length==0) await this.getItemsRequest();
          if(this.itemsubcategories.length==0) await this.getItemSubcategoriesRequest();
          if(this.promotions.length==0) this.promotions = await this.getPromotionsByPricelistRequest(this.initvalue._id);
          if(this.saleschannels.length==0) await this.getSalesChannelsRequest();
          
          console.log('subcag', this.itemsubcategories)

          this.logo = getLogo(this.initvalue.companyid);
          this.companyaddress = await this.getSetting({code: 'CompanySettings', name: 'CompanyAddress'}, );
        },
    };
</script>

<style src="./Print.scss" lang="scss" scoped />
